import {stringComparator} from "../atUtils";

/**
 * Created by filatov on 23.03.2016.
 */

function GroupValidatorStrategy(){

}

GroupValidatorStrategy.prototype.isNullGroup = function(group){
    //abstract;
};

GroupValidatorStrategy.prototype.isDefaultGroup = function(group){
    //abstract;
};

/* TimeZoneGroupValidatorStrategy*/
export function TimeZoneGroupValidatorStrategy(){}

TimeZoneGroupValidatorStrategy.prototype = new GroupValidatorStrategy();

TimeZoneGroupValidatorStrategy.prototype.isNullGroup = function(group){
    return false;
};

TimeZoneGroupValidatorStrategy.prototype.isDefaultGroup = function(group){
    return group.id == window.DEFAULT_TIME_ZONE_GROUP_ID;
};

TimeZoneGroupValidatorStrategy.prototype.getComparator = function(){
    var self = this;
    return function groupComparator(a, b) {
        if (self.isDefaultGroup(a)) {
            return (self.isDefaultGroup(b)) ? 0 : -1;
        }
        if (self.isDefaultGroup(b)) {
            return 1;
        }
        return stringComparator(a.name, b.name);
    }
};


/* UserGroupValidatorStrategy*/
export function UserGroupValidatorStrategy(){}

UserGroupValidatorStrategy.prototype = new GroupValidatorStrategy();

UserGroupValidatorStrategy.prototype.isNullGroup = function(group){
    return group.id == window.USERS_WITHOUT_GROUP_ID;
};

UserGroupValidatorStrategy.prototype.isDefaultGroup = function(group){
    return false;
};

UserGroupValidatorStrategy.prototype.getComparator = function(){
    var self = this;
    return function groupComparator(a, b) {
        if (self.isNullGroup(a)) {
            return (self.isNullGroup(b)) ? 0 : -1;
        }
        if (self.isNullGroup(b)) {
            return 1;
        }
        return stringComparator(a.name, b.name);
    }
};





// WEBPACK FOOTER //
// ./web/js/util/GroupValidatorStrategy.js